import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createBrowserHistory } from "history";
import ReactDOM from 'react-dom';
import { BrowserRouter, Router, Route, Switch } from 'react-router-dom';
import App from './App';
/*import history from "./history";*/
import registerServiceWorker, { unregister } from './registerServiceWorker';
import { MsalProvider } from '@azure/msal-react';
import msalInstance from './components/Authentication/MsalInstance';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const hist = createBrowserHistory();

msalInstance.initialize().then(() => {
    console.log("Instance", msalInstance)
    ReactDOM.render(
        <MsalProvider instance={msalInstance}>
            <Router history={hist}>
                <App />
            </Router>
        </MsalProvider>,
        rootElement);
})

//registerServiceWorker();
unregister();

